<template>
  <div id="app">
    <!-- 使用 transition 组件包裹整个加载组件 -->
    <transition name="fade" mode="out-in">
      <Loading v-if="isLoading" key="loading" />
      <div v-else key="content">
        <top :navList="navList" :navList2="navList2" :siteList="siteList[0]"/>
        <router-view :siteList="siteList[0]" :navList2="navList2" />
        <Footer :navList="navList" :siteList="siteList[0]"/>
      </div>
    </transition>
  </div>
</template>
<script>
  import top from "@/components/top";
  import Loading from "@/components/loading";
  import Footer from "@/components/footer"
  export default {
    components: {
      top,
      Loading,
      Footer
    },
    data() {
      return {
        siteList:[],
        navList: [],
        navList2: [],
        isLoading: true //初始状态为加载中
      }
    },
    created() {
      this.fetchData();
      this.getSite();
    },
    methods: {
      async getSite(){
       let res = await this.$request.post('seo/getsite')
       if (res.data.code===0) {
        this.siteList=res.data.data
       }
      },
      async fetchData() {
        try {
          const [navRes, nav2Res] = await Promise.all([
            this.getNav(),
            this.getNav2()
          ]);

          if (navRes.data.code === 0) {
            this.navList = navRes.data.data;
          }

          if (nav2Res.data.code === 0) {
            this.navList2 = nav2Res.data.data;
          }
        } catch (error) {
          console.error("数据请求失败:", error);
          // 可以在这里处理错误，例如显示错误消息
        } finally {
          this.isLoading = false; // 数据请求完成后，无论成功或失败，都隐藏加载组件
        }
      },
      async getNav() {
        return await this.$request.post('category/getAll', { fil: 1 });
      },
      async getNav2() {
        return await this.$request.post('categorysec/getAll', { fil: 1 });
      }
    },
  }
</script>

<style lang="scss">
/* 添加淡入淡出的过渡效果 */
/* 全局的淡入淡出过渡效果 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* 确保加载覆盖层在过渡期间保持不透明度 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: 1;
  transition: opacity 0.5s ease; /* 添加不透明度过渡 */
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

p {
  margin-top: 15px;
  font-size: 16px;
  color: #333;
}
</style>